import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-valutas',
  templateUrl: './valutas.component.html',
  styleUrls: ['./valutas.component.css']
})
export class ValutasComponent implements OnInit {
    public itemsListValutas: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadValutas() {
        this.itemsListValutas = await this.datatask.Post(655);
    }

    private async init() {
        this.loadValutas();
    }

    ngOnInit() {
        this.init();
    }
}
